import Form from "components/common/form/Form";
import FormActions from "components/common/form/partials/FormActions";
import ModalPortal from "components/modal/ModalPortal";
import {uuid} from "config/app-constants";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useLocation, useSearchParams} from "react-router-dom";
import {DatalistDataSourceFilterType, DatalistFilterPropsType} from "types/datalist-types";
import DatalistFilterData from "./DatalistFilterData";
import useAppContext from "../../../../../utilities/hooks/useAppContext";
import StringUtilities from "../../../../../utilities/common-utilities/string-utilities";

export const FILTER_QUERY_PARAM = 'filer';

export const FILER_MODAL_ID = 'datalist-filter';

const DatalistFilter = <T, TFilter>(props: DatalistFilterPropsType<T, TFilter>) => {
    const [t] = useTranslation();
    const [disableFormActions, setDisableFormActions] = useState(false);
    const location = useLocation();
    const context = useAppContext();
    const [searchQueryParams, setSearchQueryParams] = useSearchParams();
    const [model, setModel] = useState<DatalistDataSourceFilterType>(props.filters ? {...props.filters} : {
        id: uuid(),
        logic: 'and',
        filters: [{
            id: uuid()
        }]
    });

    let filter_query_param = props.name + "-" + FILTER_QUERY_PARAM;
    let filter_modal_id = props.name + "-" + FILER_MODAL_ID

    useEffect(() => {
        const filter = context.searchParams.get(filter_query_param);
        if (filter) {
            setModel(filter);
        } else {
            setModel(props.filters ? {...props.filters} : {
                id: uuid(),
                logic: 'and',
                filters: [{
                    id: uuid()
                }]
            });
        }
    }, [location]);

    useEffect(() => {
        filter_query_param = props.name + "-" + FILTER_QUERY_PARAM;
        filter_modal_id = props.name + "-" + FILER_MODAL_ID
    }, [props]);

    const onSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setDisableFormActions(true);
        setQueryParams(model);
        setDisableFormActions(false);
    }

    const onReset = () => {
        setQueryParams();
    }

    const setQueryParams = (filter?: DatalistDataSourceFilterType) => {
        searchQueryParams.delete(filter_query_param);
        searchQueryParams.delete(filter_modal_id);
        if (filter) searchQueryParams.append(filter_query_param, StringUtilities.stringifyValue(model));
        setSearchQueryParams(searchQueryParams, {
            replace: true
        });

        setTimeout(() => {
            props.triggerChange();
        }, 50);
    }

    if (props.columns.length === 0) {
        return <></>;
    }
    return (
        <ModalPortal
            title={t('data-list.filters')}
            name={filter_modal_id}
        >
            <div className="pb-20 md:pb-0">
                <Form onSubmit={onSubmit} onReset={onReset} name={`${props.name}-datalist-filter-form`}>
                    <DatalistFilterData
                        value={model}
                        columns={props.columns}
                        name={props.name}
                        onChange={v => setModel(v as DatalistDataSourceFilterType)}
                    />
                    <FormActions disableInputs={disableFormActions}/>
                </Form>
            </div>
        </ModalPortal>
    );
};

export default DatalistFilter;
